/**
 * POPULATIONS.TYPES.TS (for RISKS)
 * Group of person exposed to the same risks
 */
import { PhysicalRisk } from "@/entities/physical-risk/model/physical-risk.types"
import { RpsScope } from "@/entities/physical-risk/model/rps-scope"
import { RpsRisk } from "./rps-risk"
import { createRpsOptions, PopulationRpsOptions } from "./rps-evaluation"
import { v4 as uuid } from "uuid"

export const POPULATION_ENTITY = "population"

export interface Population {
  id: string
  name: string
  rpsScope: RpsScope
  rpsRisks: RpsRisk[]
  optionsRps: PopulationRpsOptions
  description: string
  size: number
  attributes: string[]

  //Relations
  EstablishmentId: string | null

  //Calculated
  cColor: string //Color of the risk the most high
  cRiskMax: null | PhysicalRisk //Risk high
  cRpsLevel: number | null //Evaluation globale de la fonction (null : evaluation incomplete)
}

export interface PopulationTemplateRisk {
  description: string
  details: string
  conséquences: string
  riskFamily?: string
}

export interface PopulationTemplate {
  code: string
  category: string
  name: string
  nafCodes?: string[]
  source: string
  risks: PopulationTemplateRisk[]
}

export interface PopulationTemplateCategory {
  code: string
  label: string
}

export interface PopulationTemplateCatalog {
  categories: PopulationTemplateCategory[]
  populations: PopulationTemplate[]
}

export const createEmptyPopulation = (overrides?: Partial<Population>): Population => {
  const defaultPopulation: Population = {
    // Id
    id: uuid(),
    name: "",
    rpsScope: { mode: "unconfigured", attributeIds: [] },
    rpsRisks: [],
    optionsRps: createRpsOptions(),
    description: "",
    size: 0,
    attributes: [],

    //Relations
    EstablishmentId: null,

    //Calculated
    cColor: "#cdcdcd",
    cRiskMax: null,
    cRpsLevel: null
  }

  return {
    ...defaultPopulation,
    ...overrides
  }
}
